import { InsuranceType } from '@weave/schema-gen-ts/dist/schemas/insurance-verification/shared/enums.pb';
import { createShallowStore, createStore } from '@frontend/store';
import { ReportModalState } from '../types/insurance-report-api.types';

type InsuranceReportStore = {
  insuranceReportModalState: ReportModalState;
  personId: string;
  setIsPersonId: (personId: string) => void;
};

const useInsuranceReportStore = createStore<InsuranceReportStore>(
  (set) => ({
    personId: '',
    setIsPersonId: (personId: string) => set((state) => ({ ...state, personId })),
    insuranceReportModalState: {
      searchValue: '',
      filterValue: '',
      insuranceType: InsuranceType.INSURANCE_TYPE_PRIMARY,
      setInsuranceType: (type: InsuranceType) =>
        set((state) => ({
          ...state,
          insuranceReportModalState: {
            ...state.insuranceReportModalState,
            insuranceType: type,
          },
        })),
      setSearchValue: (value: string) =>
        set((state) => ({
          ...state,
          insuranceReportModalState: {
            ...state.insuranceReportModalState,
            searchValue: value,
          },
        })),
      setFilterValue: (value: string) =>
        set((state) => ({
          ...state,
          insuranceReportModalState: {
            ...state.insuranceReportModalState,
            filterValue: value,
          },
        })),
    },
  }),
  {
    name: 'insuranceReportStore',
  }
);

export const useInsuranceReportShallowStore = createShallowStore<InsuranceReportStore>(useInsuranceReportStore);
